<template>
  <div class="contact">
    <!-- ***** MAKE SURE TO UPDATE THE SHIPMENT DATE RESTRICTIONS FOR THE CURRENT SCHOOL YEAR!! ***** -->
    <h3>{{orgCardKitId}} - Organism Card Form</h3>
    <h4 v-if="performingRequest" class="loading">Loading...</h4>
    <form @submit.prevent="validateBeforeSubmit" v-if="!performingRequest">
      <p class="full">Orders must be recieved <b>at least THREE weeks before the requested ship date</b>. Ship dates for orders received less than three weeks before requested ship date may be subject to adjustment based on availability of organisms.</p>
      <div class="full">
      <label>Enter last 4 digits of Organism Card Number. Please enter exactly what is on your card.</label>
      <p class="full" id="msg" v-if="msg == true">This card has already been redeemed or is invalid. Please confirm that your card is for {{ orgCardKitId }}. Click <a href="#" @click.prevent="clearKitId">here</a> to select a different unit or enter a valid card number in the field below.</p>
      <label>{{prefix}}<input id="card-num" v-model="cardNumber" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" @blur="checkRange($event)" type="number" name="orgcardnumber" maxlength="4" v-validate="'required|min:4|max:4'" :class="{ 'input': true, 'border border-danger': errors.has('orgcardnumber'), 'valid': validNumber }"></label>
      <div class="overlay" v-if="checkingMsg">
        <div class="cancel-dialogue" v-if="checkingMsg">
          <p>Checking card number...</p>
        </div>
      </div>
      <!-- <p v-if="checkingMsg" class="cancel-dialogue"></p> -->
      <p v-show="errors.has('orgcardnumber')" class="full text-danger">{{ errors.first('orgcardnumber') }}</p>
      <p v-show="errors.has('orgcardnumber')"></p>
      </div>
      <div v-if="shipments[0]" class="shipInfo">
        <h4 v-if="shipments[1]">Shipment #1 Contents ({{shipments[0].shipmentLabel}})</h4>
        <h4 v-if="!shipments[1]">Shipment Contents ({{shipments[0].shipmentLabel}})</h4>
        <p style="margin-bottom: 8px;">{{shipments[0].shipmentContents}}</p>
        <p style="margin-bottom: 5px;" v-if="orgCardKitId === '3LNG'">*I prefer to receive:</p>
        <select v-model="frogPreference" v-if="orgCardKitId === '3LNG'">
          <option disabled value="" default>Please select</option>
          <option>Eggs</option>
          <option>Tadpoles</option>
          <option>No preference</option>
        </select>
        <p style="font-size: small;" v-if="orgCardKitId === '3LNG'"><br/>*We will do our best to ship the preferred item. If eggs are unavailable, tadpoles will be shipped. If tadpoles are unavailable, eggs will be shipped.</p>
      </div>
      <div class="shipInfo" v-if="shipments[1]">
        <h4>Shipment #2 Contents ({{shipments[1].shipmentLabel}})</h4>
        <p>{{shipments[1].shipmentContents}}</p>
      </div>
      <div>
        <p v-if="shipments[1]">Shipment #1 Date</p>
        <p v-if="!shipments[1]">Shipment Date</p>
        <!-- ***** MAKE SURE TO UPDATE THE SHIPMENT DATE RESTRICTIONS FOR THE CURRENT SCHOOL YEAR!! ***** -->

        <div v-if="shipDateOne">

          <datepicker
          v-model="shipDateOne"
          name="date-picker"
          :disabled-dates="statea.disabledDates"
          :inline="true"
          v-validate="'required|date_format:yyyy-MM-dd'"
          :class="{ 'input': true, 'border border-danger': errors.has('shipDateOne') }"
          v-if="calendarToUse === 'a'"
          ></datepicker>

          <datepicker
          v-model="shipDateOne"
          name="date-picker"
          :disabled-dates="stateb.disabledDates"
          :inline="true"
          v-validate="'required|date_format:yyyy-MM-dd'"
          :class="{ 'input': true, 'border border-danger': errors.has('shipDateOne') }"
          v-if="calendarToUse === 'b'"
          ></datepicker>

          <datepicker
          v-model="shipDateOne"
          name="date-picker"
          :disabled-dates="statec.disabledDates"
          :inline="true"
          v-validate="'required|date_format:yyyy-MM-dd'"
          :class="{ 'input': true, 'border border-danger': errors.has('shipDateOne') }"
          v-if="calendarToUse === 'c'"
          ></datepicker>

        </div>
        <p v-if="!shipDateOne" style="margin: auto; color: #7b8a1d; font-weight:600; font-size: larger;">Loading Calendar...</p>

        <span v-show="errors.has('shipDateOne')" class="text-danger">{{ errors.first('shipDateOne') }}</span>
        <p id="smlTxt"><br/>Please select the MONDAY of the week you would like to receive shipment. Please note, organisms will arrive on Wednesday or Thursday of the selected week.</p>

      </div>
      
      <div class="full" style="border-top: 1px solid gray"></div>
      <p>
      <label>District</label>
      <input v-model="district" type="text" name="district" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('district') }" :disabled="!validNumber">
      <span v-show="errors.has('district')" class="text-danger">{{ errors.first('district') }}</span>
      </p>
      <p>
      <label>School Building</label>
      <input v-model="building" type="text" name="schoolBldg" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('schoolBldg') }" :disabled="!validNumber">
      <span v-show="errors.has('schoolBldg')" class="text-danger">{{ errors.first('schoolBldg') }}</span>
      </p>
      <p class="full">
      <label>Email Address</label>
      <input v-model="email" type="email" name="email" v-validate="'required|email'" :class="{ 'input': true, 'border border-danger': errors.has('email') }" :disabled="!validNumber">
      <span v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</span>
      </p>
      <p class="full">
      <label>Please Confirm Email Address</label>
      <input v-model="emailTwo" type="email" name="email02" @blur="checkEmail" v-validate="'required|email'" :class="{ 'input': true, 'border border-danger': errors.has('email02') }" :disabled="!validNumber">
      <span v-show="errors.has('email02')" class="text-danger">{{ errors.first('email02') }}</span>
      </p>
      <p class="full" id="msg02" v-if="msg02 !== ''">{{msg02}}</p>
      <p>
      <label>Teacher</label>
      <input v-model="teacher" type="text" name="teacher" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('teacher') }" :disabled="!validNumber">
      <span v-show="errors.has('teacher')" class="text-danger">{{ errors.first('teacher') }}</span>
      </p>
      <p>
      <label>Shipping Address</label>
      <input v-model="shippingAddress" type="text" name="shipAddress" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('shipAddress') }" :disabled="!validNumber">
      <span v-show="errors.has('shipAddress')" class="text-danger">{{ errors.first('shipAddress') }}</span>
      </p>
      <p>
      <label>City</label>
      <input v-model="city" type="text" name="city" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('city') }" :disabled="!validNumber">
      <span v-show="errors.has('city')" class="text-danger">{{ errors.first('city') }}</span>
      </p>
      <p>
      <label>State</label>
      <input v-model="state" type="text" name="state" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('state') }" :disabled="!validNumber">
      <span v-show="errors.has('state')" class="text-danger">{{ errors.first('state') }}</span>
      </p>
      <p>
      <label>Zip Code</label>
      <input v-model="zipCode" type="text" name="zip" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('zip') }" :disabled="!validNumber">
      <span v-show="errors.has('zip')" class="text-danger">{{ errors.first('zip') }}</span>
      </p>
      <p>
      <label>Phone Number</label>
      <input v-model="phone" type="text" name="phone" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('phone') }" :disabled="!validNumber">
      <span v-show="errors.has('phone')" class="text-danger">{{ errors.first('phone') }}</span>
      </p>
      <div class="full">
      <button type="submit" v-if="validNumber">Submit</button>
      <p class="disabled-button" v-if="!validNumber">Please enter valid card number above.</p>
      </div>
      <p class="full" style="text-align: center"><a href="#" @click="clearKitId">Cancel</a></p>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
const fb = require('./../../firebase/firebase')
import { Validator } from 'vee-validate'
import Datepicker from 'vuejs-datepicker'
const dictionary = {
  en: {
    attributes: {
      orgcardnumber: 'Organism Card Number',
      shipDateOne: 'Shipment #1 Date',
      shipDateTwo: 'Shipment #2 Date',
      district: 'District',
      schoolBldg: 'School Building',
      email: 'Email',
      email02: 'Email',
      teacher: 'Teacher',
      shipAddress: 'Shipping Address',
      city: 'City',
      state: 'State',
      zip: 'Zip Code',
      phone: 'Phone Number'
    }
  }
}

Validator.localize(dictionary)

export default {
  data() {
    return {
      msg: false,
      msg02: '',
      kitId: '',
      shipments: {},
      prefix: '',
      cardNumber: null,
      validNumber: null,
      checkingMsg: false,
      shipDateOne: null,
      shipDateOneFormatted: '',
      frogPreference: '',
      shipDateTwo: '',
      shipDateTwoFormatted: '',
      district: '',
      building: '',
      teacher: '',
      shippingAddress: '',
      city: '',
      state: '',
      zipCode: '',
      phone: '',
      email: '',
      emailTwo: '',
      performingRequest: true,
      // 3LNG = c, KLNG, 1LNG, 2LNG, 5LNG, MSLNG1 = a
      statea: {
        disabledDates: {
        to: new Date(2026, 7, 24),
        from: new Date(2027, 4, 10),
        days: [0, 2, 3, 4, 5, 6],
        dates: [
          new Date(2026, 6, 6),
          new Date(2026, 6, 13),
          new Date(2026, 6, 20),
          new Date(2026, 6, 27),
          new Date(2026, 7, 3),
          new Date(2026, 7, 10),
          new Date(2026, 7, 17),
          new Date(2026, 8, 7),
          new Date(2026, 10, 23),
          new Date(2026, 10, 30),
          new Date(2026, 11, 7),
          new Date(2026, 11, 14),
          new Date(2026, 11, 21),
          new Date(2026, 11, 28),
          new Date(2027, 0, 4),
          new Date(2027, 0, 11),
          new Date(2027, 0, 18),
          new Date(2027, 0, 25),
          new Date(2027, 1, 1),
          new Date(2027, 1, 8),
          new Date(2027, 1, 15),
          new Date(2027, 1, 22),
          new Date(2027, 4, 17),
          new Date(2027, 4, 24),
          new Date(2027, 4, 31),
          new Date(2027, 5, 7),
          new Date(2027, 5, 14),
          new Date(2027, 5, 21),
          new Date(2027, 5, 28),
        ]
        }
      },
      statec: {
        disabledDates: {
        to: new Date(2026, 7, 24),
        from: new Date(2027, 3, 26),
        days: [0, 2, 3, 4, 5, 6],
        dates: [
          new Date(2026, 6, 6),
          new Date(2026, 6, 13),
          new Date(2026, 6, 20),
          new Date(2026, 6, 27),
          new Date(2026, 7, 3),
          new Date(2026, 7, 10),
          new Date(2026, 7, 17),
          new Date(2026, 8, 7),
          new Date(2026, 10, 23),
          new Date(2026, 10, 30),
          new Date(2026, 11, 7),
          new Date(2026, 11, 14),
          new Date(2026, 11, 21),
          new Date(2026, 11, 28),
          new Date(2027, 0, 4),
          new Date(2027, 0, 11),
          new Date(2027, 0, 18),
          new Date(2027, 0, 25),
          new Date(2027, 1, 1),
          new Date(2027, 1, 8),
          new Date(2027, 1, 15),
          new Date(2027, 1, 22),
          new Date(2027, 4, 3),
          new Date(2027, 4, 10),
          new Date(2027, 4, 17),
          new Date(2027, 4, 24),
          new Date(2027, 4, 31),
          new Date(2027, 5, 7),
          new Date(2027, 5, 14),
          new Date(2027, 5, 21),
          new Date(2027, 5, 28),
        ]
        }
      },
      calendarToUse: ''
    }
  },
  components: {
    Datepicker
  },
  computed: {
    ...mapState(['orgCardKitId'])
  },
  created() {
    this.fetchTemplateContent()
    this.whichCalendar()
  },
  methods: {
    checkRange(e) {
      console.log('Checking Number Range')
      this.msg = false
      this.checkingMsg = true
      this.validNumber = null

      setTimeout(() => {
        if (this.prefix == 'KLNG-NGSS-' && Number(e.target.value) > 9099 && Number(e.target.value) < 9301) {
          console.log('Valid KLNG')
          this.checkNumber(e)
        } else if (this.prefix == '1LNG-NGSS-' && Number(e.target.value) > 1299 && Number(e.target.value) < 1501) {
          console.log('Valid 1LNG')
          this.checkNumber(e)
        } else if (this.prefix == '2LNG-NGSS-' && Number(e.target.value) > 2099 && Number(e.target.value) < 2301) {
          console.log('Valid 2LNG')
          this.checkNumber(e)
        } else if (this.prefix == '3LNG-NGSS-' && Number(e.target.value) > 3199 && Number(e.target.value) < 3401) {
          console.log('Valid 3LNG')
          this.checkNumber(e)
        } else if (this.prefix == '5LNG-NGSS-' && Number(e.target.value) > 5199 && Number(e.target.value) < 5401) {
          console.log('Valid 5LNG')
          this.checkNumber(e)
        } else if (this.prefix == 'MSLNG1-NGSS-' && Number(e.target.value) > 6549 && Number(e.target.value) < 6601) {
          console.log('Valid MSLNG1')
          this.checkNumber(e)
        } else {
          console.log('Not valid or invalid...')
          this.msg = true
          this.cardNumber = null
          this.checkingMsg = false
        }
      }, 2000)
    },
    checkNumber(e) {
      console.log('Checking for availability.')

      setTimeout(() => {
        fb.orgCardOrdersCollection.doc(this.prefix + e.target.value).get().then((doc) => {
          if (doc.exists) {
            this.msg = true
            this.cardNumber = null
            console.log('doc already exists', this.cardNumber)
            this.checkingMsg = false
          } else {
            this.msg = false
            this.validNumber = true
            this.checkingMsg = false
          }
        }).catch((error) => {
          console.log('there was an error')
          this.checkingMsg = false
        })
      }, 2000)
    },
    checkEmail() {
      if (this.email !== this.emailTwo) {
        this.msg02 = 'Emails do not match.'
        this.emailTwo = ''
      } else {
        this.msg02 = ''
      }
    },
    fetchTemplateContent() {
      setTimeout(() => {
        fb.orgCardTemplateCollection.doc(this.orgCardKitId).get().then((doc) => {
          if (doc.exists) {
            this.shipments = doc.data().shipments
            this.prefix = doc.data().prefix
          } else {
            console.log('No doc')
          }
        }).then(() => {
          let min = this.shipments[0].minDate
          let d = new Date()
          if (moment(min).subtract(3, 'week').format('YYYY-MM-DD') >= moment(d).format('YYYY-MM-DD')) {
            this.shipDateOne = new Date(min.split('-').map(Number))
            console.log(min.split('-').map(Number))
            console.log('Min Date is greater')
          } else {
            d.setDate(d.getDate() + ((7 - d.getDay()) % 7 + 1) % 7)
            console.log(d)
            console.log('Min Date is lesser')
            this.minShipDate = moment(d).add(3, 'week').format('YYYY-MM-DD')
            this.statea.disabledDates.to = new Date(this.minShipDate.split('-').map(Number))
            
            this.statec.disabledDates.to = new Date(this.minShipDate.split('-').map(Number))            
            setTimeout(() => {
              this.shipDateOne = new Date(this.minShipDate.split('-').map(Number))
              console.log('set shipDateOne')
            }, 3000)
          }
        }).then(() => {
          this.performingRequest = false
        }).catch((error) => {
          console.log('Error getting doc:', error)
        })
      }, 2000)
    },
    clearKitId() {
      this.$store.commit('SET_ORG_CARD_KIT_ID', null)
      this.$router.push('/')
    },
    checkDate() {
      this.formattedDate = moment(this.shipDateOne).format('DD-MMM-YYYY')
      console.log (this.formattedDate)
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.shipDateOneFormatted = moment(this.shipDateOne).format('DD-MMM-YYYY')
        if (this.shipDateTwo) {
          this.shipDateTwoFormatted = moment(this.shipDateTwo).format('DD-MMM-YYYY')
        } else {
          this.shipDateTwoFormatted = 'N/A'
        }
        if (result) {
          fb.orgCardOrdersCollection.doc(this.prefix + this.cardNumber).set({
            building: this.building,
            cardNumber: this.prefix + this.cardNumber,
            city: this.city,
            district: this.district,
            email: this.email,
            kitId: this.orgCardKitId,
            phone: this.phone,
            shipDate01: this.shipDateOneFormatted,
            frogPreference: this.frogPreference,
            shipDate02: this.shipDateTwoFormatted,
            shippingAddress: this.shippingAddress,
            state: this.state,
            teacher: this.teacher,
            zipCode: this.zipCode,
            dateSubmitted: moment().format('DD-MMM-YYYY'),
            dateSubmittedSortable: moment().format()
          }).then(() => {
            console.log('Doc was written.')
            this.$store.commit('SET_CONFIRMATION_MSG', 'Organism Card Order was submitted successfully.')
          }).catch((err) => {
            console.log('Error writing doc:', err)
          })
          this.clearKitId()
          return
        }
        alert('Please correct errors...')
      })
    },
    whichCalendar() {
      setTimeout(() => {
        if (this.orgCardKitId === "3LNG") {
        this.calendarToUse = 'c' 
      } else if (this.orgCardKitId === "5LNG") {
        this.calendarToUse = 'a'
      } else if (this.orgCardKitId === "MSLNG1") {
        this.calendarToUse = 'a'
      } else if (this.orgCardKitId === "KLNG") {
        this.calendarToUse = 'a'
      } else if (this.orgCardKitId === "1LNG") {
        this.calendarToUse = 'a'
      } else if (this.orgCardKitId === "2LNG") {
        this.calendarToUse = 'a'
      }
      }, 2000)
    }
  }
}
</script>

<style lang="css">
.disabled-button {
  margin: auto;
  text-align: center;
  width: 100%;
  padding: 10px;
  background-color: #616161;
  color: white;
  font-weight: 600;
}
.checking-alert {
  color: #7b8a1d;
}
.cancel-dialogue {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  border: 2px solid #cecece;
  max-width: fit-content;
  background: white;
  padding: 20px;
  text-align: center;
  margin: 20px auto;
}
.overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 50%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.valid {
  border: 1px solid yellowGreen !important;
}
</style>
